import { my_routes } from "../router/all_routes";
import { Link } from "react-router";
import Scheduler from "./scheduler";

const EdtManager = () => {
  const routes = my_routes;

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Page Header */}
        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
          <div className="my-auto mb-2">
            <h3 className="page-title mb-1">Emploi du temps</h3>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={routes.adminDashboard}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to={routes.timeTableList}>Application</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Emploi du temps
                </li>
              </ol>
            </nav>
          </div>
        </div>
        {/* /Page Header */}

        {/* Schedule */}
        <div>
          <Scheduler />
        </div>
      </div>
    </div>
  );
};

export default EdtManager;
